import { useAuth } from "./AuthContext";

const RequireResourceUserRole: React.FC = ({ children }) => {
  const auth = useAuth();

  return <>{auth.isLoggedIn && auth.role === "resource" && <>{children}</>}</>;
};

export default RequireResourceUserRole;
